export default __webpack_public_path__ + "static/media/K_wdt_c_cap_4.0f4cb11c.mp3";